import React, { useEffect } from 'react';
import { IResultsProps } from './IResults';
import { Grid } from '@mui/material';
import './Results.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../reduxService';
import { getActionByProjectType } from '../../../actionMap';
import { EProjectType } from '../../../enum/project';
import { useParams } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Results = (_props: IResultsProps) => {
    const results = useSelector((state: RootState) => state.Dynamic.results.data?.outputData);
    const { projectType } = useParams();
    const { graphic } = getActionByProjectType((projectType as EProjectType) || EProjectType.container_yard);

    useEffect(() => {
        // Update the component with the new resultsData
    }, [results]);

    return (
        <Grid container id="results-container" spacing={2}>
            <Grid item></Grid>

            <Grid className="graphic-area" item xs={12} style={{ marginTop: 40 }}>
                <Grid item xs={12}>
                    {graphic}
                </Grid>
            </Grid>

            <Grid item xs={12} style={{ marginTop: 40 }}>
                {/* Row with 4 boxes */}
                <Grid container spacing={2}></Grid>
            </Grid>
        </Grid>
    );
};

export default Results;
